import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { BorderWrapper } from 'components/styled-components';
import { H3 } from '@blueprintjs/core';
import { fetchVendorRequestHistory } from 'actions/vendor-request';
import Pagination from 'components/pagination';
import styled from 'styled-components';
import colors from 'utils/colors';
import map from 'lodash/map';
import moment from 'moment';

const LogRow = ({ status }) => {
  const { user } = status;
  const name = `${user.firstName} ${user.lastName}`;
  const initials = `${user.firstName.charAt(0)}${user.lastName.charAt(0)}`;
  return (
    <LogWrapper>
      <div style={{ width: '100%' }}>
        <LogInfo>
          <UserIcon>
            <span>{initials}</span>
          </UserIcon>
          {name}
          <span
            style={{
              fontSize: '0.75rem',
              fontWeight: '700',
              marginLeft: '0.5rem',
            }}
          >
            {moment(status.createDate).format('MMMM Do YYYY, h:mm:ss a')}
          </span>
        </LogInfo>
        <LogContent>{status.changeNote}</LogContent>
      </div>
    </LogWrapper>
  );
};

const StatusLogBase = ({
  status,
  vendorRequestID,
  fetchVendorRequestHistory,
}) => {
  const PER_PAGE = 10;
  const [currentPage, setCurrentPage] = useState(0);
  const [statusPage, setStatusPage] = useState([]);

  useEffect(() => {
    fetchVendorRequestHistory(vendorRequestID);
  }, []);

  useEffect(() => {
    setStatusPage(getStatusPage());
  }, [status, currentPage]);

  const getStatusPage = () => {
    return status.slice(currentPage * PER_PAGE, (currentPage + 1) * PER_PAGE);
  };

  const handlePageClick = page => {
    setCurrentPage(page);
    setStatusPage(getStatusPage);
  };

  return (
    <BorderWrapper margin="1rem" padding="1rem">
      <H3>Status Log</H3>
      {map(statusPage, (stat, i) => (
        <LogRow status={stat} key={i} />
      ))}
      {status.length > PER_PAGE && (
        <Pagination
          numRecords={status.length}
          perPage={PER_PAGE}
          currentPage={currentPage}
          onPageClick={handlePageClick}
          handlePerPageChange={null}
          hidePerPage={true}
        />
      )}
    </BorderWrapper>
  );
};

const LogWrapper = styled.div`
  display: flex;
  padding: 0.5rem;
  margin: 0.5rem;
`;

const LogInfo = styled.div`
  width: 90%;
  display: flex;
  align-content: baseline;
  align-items: baseline;
`;

const UserIcon = styled.div`
  border-radius: 50px;
  background: ${colors.brandingPrimary};
  text-transform: uppercase;
  font-size: 1rem;
  height: 2.2rem;
  width: 2.2rem;
  margin: 0 1rem;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const LogContent = styled.div`
  margin-left: 4.5rem;
  color: ${colors.gray};
`;

const mapStateToProps = state => ({
  status: state.vendorRequest.history,
});

const StatusLog = connect(
  mapStateToProps,
  { fetchVendorRequestHistory }
)(StatusLogBase);

export default StatusLog;
